const sitewideBanner = () => {
    const banner = document.querySelector('.sitewide-banner');

    if (!banner) return;
};

export default sitewideBanner;
